import api from 'lib/api'

export function fetchOneByPromoCode(params: { promoCode: string }) {
  return api
    .get('/api/v2/promo-codes', { params })
    .then(({ data }) => data.data)
}
